stimulusApp.register(
  "popular-filters",
  class extends Stimulus.Controller {
    static outlets = ["filters-form"]

    static suggestionClass = "filter-tags-i_suggestions"

    // The section has to open here rather than in the response: it carries
    // `morph-keep`, which vetoes the server's `open` on the chip's own morph.
    openSection({ params: { section } }) {
      const details = document.querySelector(
        `.fltrs--category[data-filter-section="${section}"] > details`,
      )
      if (details) details.open = true
    }

    apply(event) {
      const chip = event.currentTarget
      const input = document.getElementById(event.params.input)
      if (!this.#suggesting(chip) || !this.hasFiltersFormOutlet || !input)
        return

      event.preventDefault()
      this.#press(chip)
      this.filtersFormOutlet.applyFilter(input)
    }

    #suggesting(chip) {
      return chip.classList.contains(this.constructor.suggestionClass)
    }

    #press(chip) {
      chip.classList.remove(this.constructor.suggestionClass)
      chip.style.pointerEvents = "none"
      chip.removeAttribute("href")
    }
  },
)
